import clsx from "clsx";
import { ListBoxItem as AriaListBoxItem } from "react-aria-components";

import { CheckboxCheckmark } from "@/components/ui/inputs/Checkbox/CheckboxCheckmark";
import { Typography } from "@/components/ui/text/Typography/Typography";

import type { DropdownItem } from "./Dropdown";

type DropdownListItemProps = DropdownItem & {
  selectionMode?: "single" | "multiple";
};

export const DropdownListItem = ({ selectionMode = "single", ...item }: DropdownListItemProps) => {
  return (
    <AriaListBoxItem
      id={item.id}
      className={clsx(
        "group flex cursor-pointer items-center gap-2 px-2-5 py-2",
        "outline-none",
        "hover:text-interactive-text-hover",
        "focus-visible:bg-interactive-primary-focus focus-visible:text-interactive-text-on-inverted",
        "hover:bg-elevation-surface-2",
        selectionMode === "single" && [
          "bg-elevation-surface-1 text-interactive-text-on-bg",
          "selected:bg-interactive-primary-idle selected:text-interactive-text-on-inverted",
        ],
        selectionMode === "multiple" && [
          "bg-elevation-surface-1 text-interactive-text-hover",
          "selected:bg-elevation-surface-1 selected:text-interactive-text-hover",
        ],
      )}
    >
      <CheckboxCheckmark
        variant="default"
        className={clsx(selectionMode === "single" && "hidden")}
      />
      <Typography
        size="label-4"
        as="span"
      >
        {item.label}
      </Typography>
    </AriaListBoxItem>
  );
};
